<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Mark Unmark Holiday</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>From Date</b></p>
            <v-text-field outlined dense type="date" v-model="fromdate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>To Date</b></p>
            <v-text-field outlined dense type="date" v-model="todate"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="fromdate && todate">
          <v-btn color="warning" @click="fetchHolidays()">Fetch Holidays</v-btn>
        </v-row>
      </v-card>
      <v-card class="box" v-if="fetEmpCard">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Holidays</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- {{holidays_list}} -->
        <v-row justify="center" dense>
          <span v-for="(s, index) in holidays_list" :key="index">
            <v-col cols="12" sm="12" md="12">
              <!-- <label class="form-checkbox">
                <input type="checkbox" :value="s.id" v-model="holidays" />
                &nbsp;&nbsp;&nbsp;
                <span>{{ s.holiday }}</span>
                <i class="form-icon"></i>
              </label> -->
              <!-- :label="s.holiday" -->
              <v-checkbox v-model="holidays" :label="s.holiday" color="red" :value="s.id" hide-details>
                <!-- <template v-slot:label>
                  <span id="checkboxLabel">{{ s.holiday }}</span>
                </template> -->
              </v-checkbox>
            </v-col>
          </span>
        </v-row>
      </v-card>

      <v-card class="box" v-if="fetEmpCard">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Fetch Employees</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Employee Type</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type" :items="employee_type_list"
              item-text="name" item-value="id" label="Employee Type" outlined />
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Designation</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="designation" :items="designation_list"
              item-text="name" item-value="id" label="Designation" outlined />
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Section</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee_section"
              :items="employee_section_list" item-text="name" item-value="id" label="Section" outlined />
          </v-col>
          <!-- <v-col cols="12" sm="3">
                <p><b>Employee</b></p>
                <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list" item-text="name" item-value="id" label="Employee" outlined />
            </v-col> -->
        </v-row>
        <v-row justify="center" dense v-if="fromdate && todate">
          <v-btn color="warning" @click="fetchEmployees()">Fetch Employees</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="employee_list.length > 0">
        <v-toolbar flat class="toolbar">
          <v-toolbar-title>Instructor List</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row dense>
          <v-col cols="12" sm="6" md="6"></v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
              hide-details></v-text-field>
          </v-col>
        </v-row>
        <br />
        <v-data-table :headers="headers" :items="employee_list" show-select :search="search" class="elevation-1"
          v-model="selected" item-key="id" :items-per-page="-1">
          <!-- <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Instructor List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template> -->
        </v-data-table>
        <v-row justify="center" dense v-if="this.selected.length > 0">
          <v-col cols="12" sm="2"> </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="warning" @click="assignHolidays()" :disabled="holidays.length > 0 ? false : true">Assign
              Holidays</v-btn>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="red" @click="deleteHolidays()" :disabled="holidays.length > 0 ? false : true">Delete
              Holidays</v-btn>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="this.selected.length > 0">
          <strong>Total Selected - {{ selected.length }}</strong>
        </v-row>
        <v-row dense justify="center" v-if="this.selected.length > 0 && holidays.length == 0">
          <strong>Please Select Holidays.</strong>
        </v-row>
        <!-- {{selected}} -->
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    snackbar_msg: "",
    search: "",
    color: "",
    snackbar: false,
    overlay: false,
    fromdate: new Date().toISOString().slice(0, 10),
    todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
      .toISOString()
      .substr(0, 10),
    headers: [
      { text: "Sr no", value: "count" },
      { text: "Name", value: "name" },
      { text: "Employee Type", value: "employeetype" },
      { text: "Designation", value: "designation" },
      { text: "Section", value: "employeepaymentsection" },
    ],
    holidays_list: [],
    employee_type_list: [],
    designation_list: [],
    employee_section_list: [],
    employee_list: [],
    designation: "",
    employee_section: "",
    employee_type: "",
    employee: "",
    holidays: [],
    fetEmpCard: false,
    selected: [],
    total_teachers: [],
  }),
  methods: {
    cleardata() {
      this.selected = [];
      this.total_teachers = [];
      this.holidays = [];
      this.holidays_list = [];
      this.employee_list = [];
      this.designation = "";
      this.employee_section = "";
      (this.employee_type = ""), (this.fetEmpCard = false);
    },
    deleteHolidays() {
      this.total_teachers = [];
      for (var i = 0; i < this.selected.length; i++) {
        this.total_teachers.push(this.selected[i].id);
      }
      if (this.total_teachers.length <= 0) {
        this.showSnackbar("#b71c1c", "Please select Teachers!"); // show snackbar
      }
      const data = {
        holidays: this.holidays,
        instructors: this.total_teachers,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/EmployeeBiometric/deleteHolidays", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Holidays Deleted Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          // this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
          this.cleardata();
        });
    },
    assignHolidays() {
      this.total_teachers = [];
      for (var i = 0; i < this.selected.length; i++) {
        this.total_teachers.push(this.selected[i].id);
      }
      if (this.total_teachers.length <= 0) {
        this.showSnackbar("#b71c1c", "Please select Teachers!"); // show snackbar
      }
      const data = {
        holidays: this.holidays,
        instructors: this.total_teachers,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/EmployeeBiometric/assignHolidays", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Holidays Marked Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //  this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
          this.cleardata();
        });
    },
    fetchEmployees() {
      const data = {
        designation: this.designation,
        employee_section: this.employee_section,
        employee_type: this.employee_type,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/EmployeeBiometric/fetchEmployees", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.employee_list = res.data.employee_list;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    fetchHolidays() {
      const data = {
        fromdate: this.fromdate,
        todate: this.todate,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/EmployeeBiometric/fetchHolidays", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.holidays_list = res.data.holidayList;
            this.fetEmpCard = true;
            this.employee_type_list = res.data.employee_type_list;
            this.designation_list = res.data.designation_list;
            this.employee_section_list = res.data.employee_section_list;
            //  this.employee_list=res.data.employee_list
            this.employee_type = this.employee_type_list[0].id;
            this.designation = this.designation_list[0].id;
            this.employee_section = this.employee_section_list[0].id;
            //this.employee=this.employee_list[0].id
            //this.holidays.push(this.holidays_list[0].id)
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          // this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    // this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>